<template>
  <v-app id="register" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-6 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <v-spacer></v-spacer>
                  <h1 class="text-md-center">Nelson Registration</h1>
                </div>
                <v-form>
                  <v-text-field append-icon="person" name="login" label="Benutzername" type="text" v-model="model.email"></v-text-field>
                  <v-text-field append-icon="lock" name="password" label="Passwort" id="password" type="password" v-model="model.password"></v-text-field>
                  <v-text-field append-icon="lock" name="passwordRepeat" label="Passwort Wiederholen" id="passwordRepeat" type="password" v-model="model.passwordRepeat"></v-text-field>
                  <v-select multiple="multiple" eager append-icon="person" name="team" label="team"  item-text="name"  item-value="id"  v-model="model.team"  :items="teams"></v-select>
               </v-form>
                <div v-if="error" class="v-alert v-alert--outline error--text">
                  <i aria-hidden="true" class="v-icon material-icons v-alert__icon">warning</i>
                  <div>
                    {{error}}
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-flex mt-2>
                  <v-btn block color="primary" @click="register" :loading="loading">Register</v-btn>
                </v-flex>
              </v-card-actions>
              <v-card-actions>
                <v-flex mt-2>
                  <a href="#/login">Back to Login</a>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>


<script>
import Vue from 'vue'
import API from '@/api'
import colors from '../theme/colors'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import TeamsJson from './teams.json'

Vue.use(VueReCaptcha, { siteKey: '6Lcv4OEUAAAAAP3nUHZBgH0DA3o7-ax6h-OGykbc' })
export default {
  data: () => ({
    error: '',
    loading: false,
    model: {
      email: '',
      password: '',
      passwordRepeat: '',
      team: [],
    },
    teams: []
  }),

  mounted(){
    TeamsJson.forEach(element => {
      this.teams.push(element.name)
    });
  },

  methods: {
    /**
     * Sends request to backend.
     * Sets theme and jwt token in local browser storage if successful.
     * Redirects to chat window
     */
    containsDisallowedStrings(str) {
      const dissalowChars = ['#', 'http', '<', '>', '#', ':', '&', '/', '\\', 'src', 'script', '=', ')', '(', '%', ',', ';', '+', '*'];
      for (let i = 0; i < dissalowChars.length; i++) {
        const disallowedStr = dissalowChars[i];
        if (str.includes(disallowedStr)) {
          return true; // Disallowed string found
        }
      }
      return false; // No disallowed strings found
    },

    async register () {
      this.loading = true
      if(this.model.email && this.model.email.length < 3) {
        this.error = 'Login name to short!';
        this.loading = false;   
      } else if(this.model.password !== this.model.passwordRepeat) {
        this.error = 'Password and password repeat not same!';
        this.loading = false;
      } else if(this.model.password.length < 12) {
        this.error = 'Password must have at least 12 characters!';
        this.loading = false;
      } else if(this.containsDisallowedStrings(this.model.email)) {
        this.error = 'User name contains dissalowed chars!';
        this.loading = false;
      } else if (!/[A-Z]/.test(this.model.password)) {
        this.error = 'Password doesnt contains uppercase character!';
        this.loading = false;
      } else if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\-]/.test(this.model.password)) {
        this.error = 'Password doesnt contains special character!'
        this.loading = false  
      } else {

        try {
          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('login')
          const data = {
            email: this.model.email,
            password: this.model.password,
            captchaToken: token,
            team: this.model.team
          }
          
          const response = await API.register(data)          
          this.loading = false
          this.model.password = ''
          this.model.passwordRepeat = ''
          this.error = "Ihr Konto wurde erstellt. Bitte warten Sie, bis unsere Administratoren Ihr Konto aktiviert haben"
        } catch (err) {
          console.log(err)
          this.error = 'Wrong password or email address!'
          this.loading = false
        }
      }
    }
  },
  loadOnce:function(){
      
      console.log("")
    },
  beforeCreate () {
    // make sure old settings are removed
    this.$store.commit('removeToken')
  }
}
</script>
<style scoped lang="css">
  #register {
    color:#223056!important;
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
